import React, { useEffect, useState } from "react";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";

// Material UI Components
import { ClickAwayListener } from "@mui/material";

// Soft UI Dashboard PRO React components
import SoftBox from "../SoftBox";
import SoftButton from "../SoftButton";
import SoftTypography from "../SoftTypography";

// Components
import Note from "./Note";
import SendMessage from "./SendMessage";

const NoteList = ({
  notes,
  onSendMessage,
  handleClickAway,
  handleCloseNotes
}) => {
  const MAX_ITEMS = 5;
  return (
    <ClickAwayListener onClickAway={(e) => {
      const isNoteClick = (
        e.target.nodeName?.toLowerCase() === "span" &&
        e.target?.innerText?.includes("Note"));
      handleClickAway?.(isNoteClick)
    }}>
      <SoftBox
        id="notelist"
        sx={{
          backgroundColor: "#FFFFFF",
          borderRadius: "20px",
          width: "100%",
          maxWidth: { mini: "90vw", xs: "90vw", sm: "420px" },
          padding: "1.75rem",
          boxShadow: "0px 24px 48px -8px rgba(16,24,40,0.18), inset 0px 1px 0px 0px rgba(255,255,255,0.7)",
          border: "1px solid rgba(15,23,42,0.08)",
        }}
      >
        {/** Title */}
        <SoftBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <SoftTypography sx={{ textFillColor: "#0F172A" }} variant="h6" component="h2">
            Notes
          </SoftTypography>
          <SoftButton
            variant="outlined"
            color="dark"
            onClick={handleCloseNotes}
            sx={{
              "& svg": { fontSize: "1.25rem !important" },
              borderRadius: "50%",
              minWidth: "max-content",
              minHeight: "max-content",
              padding: "0.25rem",
              color: "#0F172A !important",
              borderColor: "rgba(15,23,42,0.10) !important",
            }}
          >
            <CloseIcon />
          </SoftButton>
        </SoftBox>
        <hr style={{ marginTop: '1rem', marginBottom: '1rem' }} />

        {/** Notes List */}
        <div style={{ minHeight: "70px", maxHeight: "320px", overflowY: "auto" }}>
          {(notes === null || notes?.length === 0)
            ? (
              <SoftTypography sx={{ color: "#98A2B3", fontSize: "13px", textAlign: "center", padding: "24px 0" }}>
                {notes === null ? "Loading notes..." : "No notes yet"}
              </SoftTypography>
            )
            : notes?.map((note, index) => {
              // Display only the latest MAX_ITEMS notes
              if (index < MAX_ITEMS) {
                return <Note
                  key={note?._id ?? index}
                  date={moment(note?.createdAt ?? new Date()).format("D MMM YYYY ddd hh:mm A")}
                  name={`${note?.users[0].firstName} ${note?.users[0].lastName}`}
                  note={note?.content}
                  profile={note?.users[0]?.image}
                />
              }
            })
          }
        </div>

        {/** Send Message */}
        <div style={{ marginTop: "1.25rem" }}>
          <SendMessage
            disabled={(notes === null)}
            handleSendClick={onSendMessage}
          />
        </div>
      </SoftBox>
    </ClickAwayListener>
  )
}

export default NoteList;
